import { SolidExclamationCircleIcon } from '@tempmee/react-icons';
import { Row, Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { EnforcePostAJobFunnelImprovements } from '~/constants/ff.posthog';
import { useFeatureFlag } from '~/hooks/useFeatureFlag';

export const GeneralErrorMessage = () => {
  const isEnforcePostAJobFunnelImprovement = useFeatureFlag(EnforcePostAJobFunnelImprovements);

  return (
    <Row
      gap={2}
      align="center"
      width={isEnforcePostAJobFunnelImprovement ? '800px' : undefined}
      className={isEnforcePostAJobFunnelImprovement ? undefined : 'mb-4'}
    >
      <SolidExclamationCircleIcon color={colors.error[500]} />
      <Typography as="span" color={colors.error[500]}>
        Oops! It looks like a few required fields were left empty.
      </Typography>
    </Row>
  );
};
